// '숫자'와 '-' 만 있는지 검증하는 함수
export const validatePhoneNumber = (value: string) => {
  return /^[0-9-]+$/.test(value);
};

// 번호만 입력해서 추가하려고 할 때, 번호 포맷 검증하는 함수
export const validateNumberLength = (value: string) => {
  // 문자열에서 숫자만 추출
  const numbersOnly = value.replace(/\D/g, '');
  // 숫자의 길이가 8 이상 13 이하인지 확인
  return numbersOnly.length >= 8 && numbersOnly.length <= 13;
};
